<div class="_client-desktop-page">

    <segment-desktop-component [segments]="segments" [selectedSegment]="selectedSegment" (selectedSegmentChange)="onSelectedSegmentChange($any($event))"></segment-desktop-component>

	<ng-container [ngSwitch]="selectedSegment">

        <!-- Client details -->
        <div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[0])">
            <page-header-component title="{{client.firstname}} {{client.lastname}}">
                <ng-container right *ngIf="client?.id">
                    <ng-container *ifUserHasPermissions="[UserPermissions.DeleteClients]">
                        <button type="button" right class="_button _delete-button" (click)="deleteClient()">
                            <ion-icon src="./assets/icons/trash-outline.svg"></ion-icon>
                            <span>{{ 'CLIENT.DELETE' | translate}}</span>
                        </button>
                    </ng-container>
                </ng-container>
            </page-header-component>
            <div class="_container">
                <form-client *ngIf="clientForm" [formGroup]="clientForm" [edit]="true"></form-client>
                <ng-container>
                    <div class="_buttons">
                        <button type="button" class="_button _update" (click)="updateClient()"><span>{{ 'CLIENT.UPDATE' | translate}}</span></button>
                    </div>
                </ng-container>
            </div>
        </div>


        <!-- Client History -->
        <div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[1])">
            <page-header-component title="{{client.firstname}} {{client.lastname}}"></page-header-component>
            <div class="_container _history-container">
                <table-desktop-component [headers]="tableHeaders" [dataRequest]="dataRequest" (dataChanged)="dataChanged($any($event))" stateKey="client-history" [embedded]="true">
            
                    <ion-row 
                        data 
                        class="_row _data ion-align-items-center" 
                        *ngFor="let item of history; let i = index" 
                        [ngClass]="{'_offset': i % 2 !== 0}" 
                        [ngStyle]="{'border-left-color': item?.Reservation ? item.Reservation.Event.color : item?.Loan ? '#edb142' : '#78BC61'}"
                    >
		
                        <table-col header="{{'CLIENT.HISTORY.TYPE' | translate}}" [size]="2">
                            <ng-container *ngIf="item.Loan">
                                <p [translate]="'CLIENT.HISTORY.LOAN'"></p>
                            </ng-container>
                            <ng-container *ngIf="item.Reservation">
                                <p>{{item.Reservation.Event.EventType.name}}</p>
                            </ng-container>
                            <ng-container *ngIf="item.BeegoAppointment">
                                <p [translate]="'CLIENT.HISTORY.BEEGO_APPOINTMENT'"></p>
                            </ng-container>
                        </table-col>
                        <table-col header="{{'CLIENT.HISTORY.NAME' | translate}}" [size]="3">
                            <ng-container *ngIf="item.Loan">
                                <ng-container *ngFor="let device of item.Loan.Devices">
                                    <p>{{device.DeviceType.name}} ({{device.serial}})</p>
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="item.Reservation">
                                <p>{{item.Reservation.Event.name}}</p>
                            </ng-container>
                        </table-col>
                        <table-col header="{{'CLIENT.HISTORY.STARTS_AT' | translate}}{{'CLIENT.HISTORY.ENDS_AT' | translate}}" [size]="2">
                            <ng-container *ngIf="item.Loan">
                                <p>{{item.Loan.startsAt | date:"dd/MM/yyyy - HH:mm"}}</p>
                                <p *ngIf="item.Loan.endsAt !== item.Loan.startsAt">{{item.Loan.endsAt | date:"dd/MM/yyyy - HH:mm"}}</p>
                            </ng-container>
                            <ng-container *ngIf="item.Reservation">
                                <p *ngIf="item.Reservation.startsAt">{{item.Reservation.startsAt | date:"dd/MM/yyyy - HH:mm"}}</p>
                                <p *ngIf="!item.Reservation.startsAt">{{item.Reservation.CalendarEvent.startsAt | date:"dd/MM/yyyy - HH:mm"}}</p>
                               
                                <p *ngIf="item.Reservation.endsAt && item.Reservation.endsAt !== item.Reservation.startsAt">{{item.Reservation.endsAt | date:"dd/MM/yyyy - HH:mm"}}</p>
                                <p *ngIf="!item.Reservation.endsAt && (item.Reservation.CalendarEvent.endsAt !== item.Reservation.CalendarEvent.startsAt)">{{item.Reservation.CalendarEvent.endsAt | date:"dd/MM/yyyy - HH:mm"}}</p>
                            </ng-container>
                            <ng-container *ngIf="item.BeegoAppointment">
                                <p>{{item.BeegoAppointment.CalendarEvent.startsAt | date:"dd/MM/yyyy - HH:mm"}}</p>
                                <p *ngIf="item.BeegoAppointment.CalendarEvent.endsAt !== item.BeegoAppointment.CalendarEvent.startsAt">{{item.BeegoAppointment.CalendarEvent.endsAt | date:"dd/MM/yyyy - HH:mm"}}</p>
                            </ng-container>
                        </table-col>
                        <table-col header="{{'CLIENT.HISTORY.QUESTION' | translate}}" [size]="3">
                            <ng-container *ngIf="item.Reservation">
                                <p>{{item.Reservation.question}}</p>
                            </ng-container>
                            <ng-container *ngIf="item.BeegoAppointment">
                                <p [translate]="'CLIENT.HISTORY.BEEGO_APPOINTMENT_QUESTION'"></p>
                            </ng-container>
                        </table-col>
                        <table-col  header="{{'CLIENT.HISTORY.STATUS' | translate}}" [size]="2">
                            <span *ngIf="item.Reservation && item.Reservation?.Attendance.status === 'present'">
                                {{'CLIENT.HISTORY.PRESENT' | translate}}
                            </span>
                            <span *ngIf="item.Reservation && item.Reservation?.Attendance.status === 'absent'">
                                {{'CLIENT.HISTORY.ABSENT' | translate}}
                            </span>

                            <span *ngIf="item.BeegoAppointment"> 
                                <span *ngIf="item.BeegoAppointment.isCancelled; else complete">
                                    {{'CLIENT.HISTORY.CANCELLED' | translate}}
                                </span>
                                <ng-template #complete>
                                    {{'CLIENT.HISTORY.COMPLETE' | translate}}
                                </ng-template>
                            </span>
                        </table-col>
                        <table-col class="_col _rating" [size]="2">
                            @if (item.Reservation?.Rating?.score) {
                                <span tooltip="{{item.Reservation.Rating.note}}" [hideDelay]="0" theme="light" [display]="!!item.Reservation.Rating.note">
                                    @if (item.Reservation.Rating.score) {
                                       @for (i of [1,2,3,4,5]; track $index) {
                                          @if (item.Reservation.Rating.score >= i) {
                                              <ion-icon src="./assets/icons/star.svg"></ion-icon>
                                          } @else {
                                              <ion-icon style="color: lightgrey" src="./assets/icons/star-outline.svg"></ion-icon>
                                          }
                                          
                                      }
                                    }
                                 </span>
                            }
                            
                         </table-col>
                        <table-col>
                            <button type="button" class="_button _info-button" (click)="openLoanOrReservation(item)">
                                <ion-icon src="./assets/icons/info-outline.svg"></ion-icon>
                            </button>
                        </table-col>
                        
                    </ion-row>
            
                </table-desktop-component>
            </div>
        </div>

    </ng-container>

    

</div>
